import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import React from "react";
import styled from "styled-components";
var PreviewContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  bottom: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: auto;\n  display: flex;\n  .prev,\n  .next {\n    width: 36px;\n    flex: 0 0 36px;\n    height: 36px;\n    position: relative;\n    background: #5a6677;\n    border-radius: 50%;\n    margin: 0 32px;\n    cursor: pointer;\n    :after {\n      content: \"\";\n      position: absolute;\n      width: 12px;\n      height: 12px;\n      background: none;\n      border-right: 2px solid #fff;\n      border-bottom: 2px solid #fff;\n      transform: rotateZ(-45deg) translate(-1px, 16px);\n    }\n    &.disabled {\n      opacity: 0.5;\n      pointer-events: none;\n    }\n  }\n  .prev:after {\n    transform: rotateZ(135deg) translate(-2px, -19px);\n  }\n"])));
var OptActions = function OptActions(props) {
  return /*#__PURE__*/React.createElement(PreviewContainer, {
    style: props.style || {}
  }, /*#__PURE__*/React.createElement("div", {
    className: "prev ".concat(props.noPrev ? "disabled" : ""),
    onClick: function onClick() {
      return props.onPrev();
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "next ".concat(props.noNext ? "disabled" : ""),
    onClick: function onClick() {
      return props.onNext();
    }
  }));
};
OptActions.defaultProps = {
  onNext: function onNext() {},
  onPrev: function onPrev() {},
  noPrev: false,
  noNext: false
};
export default OptActions;